// FULL FILE REPLACEMENT:

import {
  EStatementAgentPayload,
  EStatementDownloadPayload,
} from "@shared/interfaces/e-statement";

const PREFIX = "E-STATEMENT";

export class POST_AGENT_DETAIL {
  public static readonly type = `[${PREFIX}] POST STATEMENT DETAIL`;
  constructor(public readonly payload: EStatementAgentPayload) {}
}

export class GET_ESTATEMENT_LOV {
  public static readonly type = `[${PREFIX}] GET ESTATEMENT LOV`;
  constructor(public readonly payload: string) {}
}

export class GET_USER_BRANCHLIST {
  public static readonly type = `[${PREFIX}] GET USER BRANCHLIST`;
  constructor(public readonly payload: string) {}
}

export class GET_YEAR_LIST {
  public static readonly type = `[${PREFIX}] GET YEAR LIST`;
  constructor(public readonly payload: string) {}
}

export class GET_AGENT_LIST {
  public static readonly type = `[${PREFIX}] GET AGENT LIST`;
  constructor(public readonly payload: EStatementAgentPayload) {}
}

export class GET_USER_AGENT_LIST {
  public static readonly type = `[${PREFIX}] GET USER AGENT LIST`;
  constructor(public readonly payload: string) {}
}

export class DOWNLOAD_CP58 {
  public static readonly type = `[${PREFIX}] DOWNLOAD CP58`;
  constructor(public readonly payload: EStatementDownloadPayload) {}
}

export class DOWNLOAD_PROFIT_COMM {
  public static readonly type = `[${PREFIX}] DOWNLOAD PROFIT COMM`;
  constructor(public readonly payload: EStatementDownloadPayload) {}
}

export class RESET_ESTATEMENT {
  public static readonly type = `[${PREFIX}] RESET ESTATEMENT`;
}
